import { createFileRoute, redirect } from '@tanstack/react-router';
import { compareBountiesByDefault } from './-bountySort';

export const Route = createFileRoute('/games/bounty-board/')({
    loaderDeps: ({ search: { list } }) => ({ list }),
    loader: async ({ context: { classic, platformer }, deps: { list } }) => {
        const bounties = list === 'classic' ? classic : platformer;
        const now = new Date();
        const firstBounty = [...bounties].sort((a, b) =>
            compareBountiesByDefault(a, b, now),
        )[0];

        if (firstBounty) {
            throw redirect({
                to: '/games/bounty-board/$bountyid',
                params: { bountyid: firstBounty.id },
                replace: true,
            });
        }
    },
});
